import { useCallback, useState } from "react";

import { useAppDispatch } from "../redux/hooks";
import { useAppSelector } from "../redux/hooks";
import { usePostSessionMutation } from "../redux/services/vectormapsAPI";
import {
  setSessionId,
  setSessionLastUpdate,
} from "../redux/slices/applicationSlice";

export const useSession = () => {
  const dispatch = useAppDispatch();

  const { queryParamsConfig } = useAppSelector((state) => state.application);
  const [postSession] = usePostSessionMutation();

  const [sessionInitialized, setSessionInitialized] = useState(false);

  const handlePostSession = useCallback(
    async (project: string) => {
      if (sessionInitialized) return;
      setSessionInitialized(true);

      if (queryParamsConfig.debug === "enable") {
        dispatch(setSessionId("DEBUG"));
        return;
      }

      try {
        const { uuid } = await postSession({ project }).unwrap();
        dispatch(setSessionId(uuid));
        dispatch(setSessionLastUpdate(new Date().toISOString()));
      } catch (e) {
        console.error(e);
      }
    },
    [dispatch, postSession, queryParamsConfig, sessionInitialized],
  );

  return {
    createSession: handlePostSession,
  };
};
